import axios from 'axios';
import { Form, Formik, FormikProps } from 'formik';
import { useRef, useState } from 'react';
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import authApis from '../../../APIs/auth';
import handsake from '../../../assets/icons/handSake.svg';
import lock from '../../../assets/icons/Lock.svg';
import logo from '../../../assets/icons/logo.svg';
import mail from '../../../assets/icons/Mail.svg';
import user, {
  ReactComponent as UserSVG,
} from '../../../assets/icons/User.svg';
import escConstants from '../../../constants';
import { useRoot } from '../../../context/RootProvider';
import {
  Alert,
  Button,
  FormContainer,
  Input,
  SelectDropdown,
  Typography,
} from '../../../designComponents';
import theme from '../../../theme';
import { requestAPI } from '../../../utils';
import { generatePassword } from '../../../utils/generateRandomPassword';
import {
  ContentContainer,
  Heading,
  Label,
  LoginContainer,
  Logo,
} from './style';
import validation from './validation';

interface initialValuesTypes {
  fullName: string;
  emailAddress: string;
  password: string;
  confirmPassword: string;
  role: string;
}

const Register = () => {
  const navigate = useNavigate();
  const { setAuth } = useRoot();
  const [loading, setLoading] = useState(false);
  const [initialValues, _setIntialValues] = useState<initialValuesTypes>({
    fullName: '',
    emailAddress: '',
    password: '',
    confirmPassword: '',
    role: '',
  });
  const formikRef = useRef<FormikProps<initialValuesTypes>>(null);

  const [isClickedEyeButton, setIsClickedEyeButton] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleRegister = async (values: any) => {
    try {
      setErrorMessage('');
      setLoading(true);
      const registerData = await requestAPI(
        authApis.register({
          emailAddress: values.emailAddress,
          fullName: values.fullName,
          password: values.password,
          role: values.role,
        }),
      );

      if (registerData?.user?._id) {
        setAuth(registerData?.user);
        // localStorage.setItem(
        //   escConstants.LOCAL_STORAGE_KEY.accessKey,

        //   registerData?.token
        // );
        axios.defaults.headers.Authorization = `Bearer ${registerData?.token}`;
        // localStorage.setItem(
        //   escConstants.LOCAL_STORAGE_KEY.refreshKey,
        //   registerData?.refreshToken
        // );
        localStorage.setItem(
          escConstants.LOCAL_STORAGE_KEY.user,
          JSON.stringify(registerData?.data?.user),
        );
      }

      toast(escConstants.toastMessages.signup);
      setLoading(false);
      navigate('/verification-code');
    } catch (error: any) {
      if (typeof error === 'string') {
        setErrorMessage(error);
      }
      if (error.error && typeof error.error === 'string') {
        setErrorMessage(error.error);
      }
      setLoading(false);
      console.error('Registration failed:', error);
    }
  };

  const handleGenerateRandomPassword = () => {
    const password = generatePassword();
    if (formikRef.current) {
      formikRef.current.setFieldValue('password', password);
      formikRef.current.setFieldValue('confirmPassword', password);
    }
  };
  return (
    <LoginContainer>
      <ContentContainer>
        <Heading>
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
          >
            <Typography variant="heading" strong>
              Evacuation Plans
            </Typography>
            <Typography style={{ marginLeft: '45px', color: '#3D3D3D' }}>
              SaaS Application
            </Typography>
          </div>
          <div>
            <Logo src={logo} alt="logo" />
          </div>
        </Heading>

        <Label>
          <img src={handsake} alt="handsake" />
          <Typography size={16} color={theme.colors.normalText}>
            Register to Escape Plan
          </Typography>
        </Label>
        <Formik
          initialValues={initialValues}
          enableAutoFill={false}
          onSubmit={handleRegister}
          enableReinitialize
          validationSchema={validation.Register}
          innerRef={formikRef}
        >
          {({ values, setFieldValue, errors, handleSubmit, touched }) => {
            console.log(values, 'valies');

            return (
              <Form onSubmit={handleSubmit} autoComplete="off">
                <FormContainer
                  label="Full Name"
                  error={touched?.fullName ? errors.fullName : ''}
                  marginBottom="20px"
                >
                  <Input
                    name="fullName"
                    value={values.fullName}
                    onChange={(e) => setFieldValue('fullName', e.target.value)}
                    placeholder="Enter full name"
                    iconLeft={<img src={user} alt="user icon" />}
                    autoComplete="off"
                  />
                </FormContainer>
                <FormContainer
                  label="Email Address"
                  error={touched?.emailAddress ? errors.emailAddress : ''}
                  marginBottom="20px"
                >
                  <Input
                    name="emailAddress "
                    value={values.emailAddress}
                    onChange={(e) =>
                      setFieldValue('emailAddress', e.target.value)
                    }
                    placeholder="Enter emailAddress "
                    iconLeft={<img src={mail} alt="mail icon" />}
                    autoComplete="off"
                  />
                </FormContainer>
                <FormContainer label="Role">
                  <SelectDropdown
                    icons={<UserSVG />}
                    onSelect={(value: string, _record: any) => {
                      setFieldValue('role', value);
                    }}
                    selected={values.role || ''}
                    name="userType"
                    placeholder="Select a user type"
                    options={[
                      {
                        label: 'Client',
                        value: 'CLIENT',
                        record: {
                          label: 'Client',
                          value: 'CLIENT',
                        },
                      },
                      {
                        label: 'Technician',
                        value: 'TECHNICIAN',
                        record: {
                          label: 'Technician',
                          value: 'TECHNICIAN',
                        },
                      },
                      {
                        label: 'Printer',
                        value: 'PRINTER',
                        record: {
                          label: 'Printer',
                          value: 'PRINTER',
                        },
                      },
                      {
                        label: 'Admin',
                        value: 'ADMIN',
                        record: {
                          label: 'Admin',
                          value: 'ADMIN',
                        },
                      },
                    ]}
                  />
                </FormContainer>
                <FormContainer
                  label="Password"
                  error={touched?.password ? errors.password : ''}
                  marginBottom="20px"
                >
                  <Input
                    type={isClickedEyeButton ? 'text' : 'password'}
                    name="password"
                    value={values.password || ''}
                    onChange={(e) => setFieldValue('password', e.target.value)}
                    placeholder="Enter password"
                    iconLeft={<img src={lock} alt="lock icon" />}
                    iconRight={
                      <div
                        role="button"
                        onClick={() => setIsClickedEyeButton((prev) => !prev)}
                      >
                        {isClickedEyeButton ? (
                          <IoEyeOutline size={18} />
                        ) : (
                          <IoEyeOffOutline size={18} />
                        )}
                      </div>
                    }
                    autoComplete="off"
                  />
                </FormContainer>
                <Button
                  onClick={handleGenerateRandomPassword}
                  variant="secondary"
                  bgColor={theme.colors.darkSlateGray.faded}
                  style={{ marginBottom: '20px' }}
                >
                  Generate Password
                </Button>
                <FormContainer
                  label="Confirm Password"
                  error={touched?.confirmPassword ? errors.confirmPassword : ''}
                  marginBottom="20px"
                >
                  <Input
                    type={isClickedEyeButton ? 'text' : 'password'}
                    name="confirmPassword"
                    value={values.confirmPassword || ''}
                    onChange={(e) =>
                      setFieldValue('confirmPassword', e.target.value)
                    }
                    placeholder="Enter confirm password"
                    iconLeft={<img src={lock} alt="lock icon" />}
                    iconRight={
                      <div
                        role="button"
                        onClick={() => setIsClickedEyeButton((prev) => !prev)}
                      >
                        {isClickedEyeButton ? (
                          <IoEyeOutline size={18} />
                        ) : (
                          <IoEyeOffOutline size={18} />
                        )}
                      </div>
                    }
                    autoComplete="off"
                  />
                </FormContainer>
                {errorMessage && (
                  <div style={{ marginBottom: '10px' }}>
                    <Alert text={errorMessage} type="error" />
                  </div>
                )}

                <Button
                  type="submit"
                  variant="primary"
                  size="lg"
                  width="100%"
                  style={{ marginBottom: '15px' }}
                  isLoading={loading}
                >
                  Register
                </Button>
              </Form>
            );
          }}
        </Formik>
        <Typography
          style={{
            display: 'flex',
            justifyContent: 'center',
            color: '#616161',
          }}
        >
          Already have an account?{' '}
          <span
            style={{
              color: '#3D3D3D',
              marginLeft: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
            }}
            onClick={() => {
              navigate('/login');
            }}
          >
            Login
          </span>
        </Typography>
      </ContentContainer>
    </LoginContainer>
  );
};

export default Register;
